const Role = {
    ADMIN: 'ADMIN',
    MANAGER: 'MANAGER',
    ANALYST: 'ANALYST',
    REVIEWER: 'REVIEWER',
    USER: 'USER',
    DEACTIVATED: 'DEACTIVATED'
};

export default Role;

export function getRoleHelpText(role) {
  switch (role) {
    case Role.ADMIN:
      return 'Administrators have full read/write system access';
    case Role.REVIEWER:
      return 'Reviewers can view the dashboard to approve or reject form submissions';
    case Role.MANAGER:
      return 'Managers have partial read/write system access';
    case Role.ANALYST:
      return 'Analysts have read-only access to the dashboard';
    default:
      return 'Users have no dashboard access';
  }
}

export function getRoleFriendlyName(role) {
  switch (role) {
    case Role.ADMIN:
      return 'Administrator';
    case Role.REVIEWER:
      return 'Reviewer';
    case Role.MANAGER:
      return 'Manager';
    case Role.ANALYST:
      return 'Analyst';
    case Role.DEACTIVATED:
      return 'Deactivated';
    default:
      return 'User';
  }
}

export function getRoleOptions(role) {
  const options = [
    role === Role.ADMIN && {'ADMIN': 'Administrator'},
    {'MANAGER': 'Manager'},
    {'REVIEWER': 'Reviewer'},
    {'ANALYST': 'Analyst'},
    {'USER': 'User'}
  ].filter(Boolean);

  return options;
}